module.exports = __webpack_public_path__ + "static/media/color-wave.e797508a.svg";